import { render } from "./TableFeedback.vue?vue&type=template&id=23ee8a2a&scoped=true&ts=true"
import script from "./TableFeedback.vue?vue&type=script&lang=ts"
export * from "./TableFeedback.vue?vue&type=script&lang=ts"

import "./TableFeedback.vue?vue&type=style&index=0&id=23ee8a2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ee8a2a"]])

export default __exports__